// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__1V5Xk","cell":"Item_cell__1b8Hb","latestReadingWidgets":"Item_latestReadingWidgets__Vk3cw","highPriorityIcon":"Item_highPriorityIcon__aONk3"};